import _typeof from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.fixed.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import { LoadListFields, SaveListFields as _SaveListFields, LoadData } from '@/api/ListParam';
import Sortable from 'sortablejs';
import util from '@/libs/util';
import { mapGetters } from 'vuex';
export default function (_ref) {
  var _ref$loadData = _ref.loadData,
      loadData = _ref$loadData === void 0 ? 'search' : _ref$loadData,
      _ref$mesTableRef = _ref.mesTableRef,
      mesTableRef = _ref$mesTableRef === void 0 ? 'MesTable' : _ref$mesTableRef,
      _ref$fastSearchRef = _ref.fastSearchRef,
      fastSearchRef = _ref$fastSearchRef === void 0 ? 'fastSearch' : _ref$fastSearchRef,
      _ref$formData = _ref.formData,
      formData = _ref$formData === void 0 ? 'formData' : _ref$formData,
      _ref$defaultLoadDataA = _ref.defaultLoadDataApi,
      defaultLoadDataApi = _ref$defaultLoadDataA === void 0 ? function (e) {
    return new Promise(e);
  } : _ref$defaultLoadDataA;
  return {
    name: 'SettingFieldTable',
    data: function data() {
      return {
        sortableColumn: null,
        mainKeys: [],
        columnsWhere: []
      };
    },
    computed: _objectSpread({}, mapGetters(['userinfo'])),
    created: function created() {
      this.mainKeysLoad(); // 获取表格字段
      // this.columnDrop() // 列拖动
    },
    beforeDestroy: function beforeDestroy() {
      if (this.sortableColumn) {
        this.sortableColumn.destroy();
      }
    },
    watch: {
      mainKeys: {
        handler: function handler() {
          this.handleSearchTableLoad(); // 获取表格配置
        }
      }
    },
    methods: {
      SeniorSearch: function SeniorSearch(val) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var theadParamList, ParamList;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  theadParamList = _this.$refs[fastSearchRef].getParamList();
                  ParamList = _this.mergeParamList(theadParamList, val);
                  _this[formData].ParamList = ParamList;
                  _context.prev = 3;
                  _context.next = 6;
                  return _this[loadData]();

                case 6:
                  _this[formData].ParamList = [];
                  _context.next = 12;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t0 = _context["catch"](3);
                  util.log.danger('未找到混入组件的' + loadData + '方法');

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[3, 9]]);
        }))();
      },
      columnDrop: function columnDrop() {
        var _this2 = this;

        this.$nextTick(function () {
          var $table = _this2.$refs[mesTableRef].$refs.xTable;
          _this2.sortableColumn = Sortable.create($table.$el.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row'), {
            handle: '.vxe-header--column:not(.col--fixed)',
            onEnd: function () {
              var _onEnd = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2) {
                var item, newIndex, oldIndex, _$table$getTableColum, fullColumn, tableColumn, targetThElem, wrapperElem, newColumn, oldColumnIndex, newColumnIndex, currRow, fullColumns;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        item = _ref2.item, newIndex = _ref2.newIndex, oldIndex = _ref2.oldIndex;
                        _$table$getTableColum = $table.getTableColumn(), fullColumn = _$table$getTableColum.fullColumn, tableColumn = _$table$getTableColum.tableColumn;
                        targetThElem = item;
                        wrapperElem = targetThElem.parentNode;
                        newColumn = fullColumn[newIndex];

                        if (!newColumn.fixed) {
                          _context2.next = 8;
                          break;
                        }

                        // 错误的移动
                        if (newIndex > oldIndex) {
                          wrapperElem.insertBefore(targetThElem, wrapperElem.children[oldIndex]);
                        } else {
                          wrapperElem.insertBefore(wrapperElem.children[oldIndex], targetThElem);
                        }

                        return _context2.abrupt("return", _this2.$message.error('当前列不允许拖动！'));

                      case 8:
                        // 转换真实索引
                        oldColumnIndex = $table.getColumnIndex(tableColumn[oldIndex]);
                        newColumnIndex = $table.getColumnIndex(tableColumn[newIndex]); // 移动到目标列

                        currRow = fullColumn.splice(oldColumnIndex, 1)[0];
                        fullColumn.splice(newColumnIndex, 0, currRow);
                        $table.loadColumn(fullColumn);
                        _context2.next = 15;
                        return _this2[loadData]();

                      case 15:
                        fullColumns = [];
                        fullColumn.forEach(function (item, index) {
                          if (item.property) {
                            var obj = {};
                            obj.ORD_IDX = index === 0 ? index + 1 : index;
                            obj.FIELD_NAME = item.property;
                            obj.FIELD_CAPTION = item.title;
                            obj.FIELD_WIDTH = item.minWidth;
                            obj.IS_VISIBLE = item.visible === true ? 'Y' : 'N';
                            obj.USER_NAME = _this2.userinfo.USER_NAME;
                            fullColumns.push(obj);
                          }
                        }); // console.log(fullColumns)

                        _SaveListFields(fullColumns); // console.log(fullColumn)
                        // await this.refreshReset()
                        // $table.refreshColumn()
                        // $table.updateData()


                      case 18:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              function onEnd(_x) {
                return _onEnd.apply(this, arguments);
              }

              return onEnd;
            }()
          });
        });
      },
      handleSearchTableLoad: function handleSearchTableLoad() {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var res;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return LoadData({
                    Page: 1,
                    Limit: 999
                  });

                case 2:
                  res = _context3.sent;

                  // console.log('高级配置list res',res);
                  if (res.code === 0) {
                    _this3.handelMergeColumn(res.data, _this3.mainKeys);
                  }

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))();
      },

      /*
        settData  高级配置list
        tableKeys 表格列
      */
      handelMergeColumn: function handelMergeColumn(settData, tableKeys) {
        var _this4 = this;

        // console.log('settData',settData);
        // console.log('tableKeys',tableKeys);
        this.$nextTick(function () {
          var targenKeys = [];
          tableKeys.forEach(function (item) {
            return targenKeys.push(item.FIELD_NAME);
          });
          var resoreKeys = [];
          settData.forEach(function (item) {
            return resoreKeys.push(item.PARAM_NAME);
          });
          var indexSearch = [];
          targenKeys.map(function (item) {
            indexSearch.push(resoreKeys.indexOf(item));
          });
          var tempData = [];
          indexSearch.map(function (item, index) {
            var obj = {};

            if (item === -1) {
              obj.FIELD_NAME = tableKeys[index].FIELD_NAME;
              obj.PARAM_NAME = tableKeys[index].FIELD_NAME;
              obj.PARAM_CAPTION = tableKeys[index].FIELD_NAME;
              obj.IS_PAGING = 'N';
              obj.DATA_TYPE = 1;
              obj.ACTION_TYPE = 6;
              obj.disabled = true;
              obj.IS_FAST_SEARCH = 'N';
              tempData.push(obj);
            } else {
              obj.FIELD_NAME = settData[item].FIELD_NAME;
              obj.PARAM_NAME = settData[item].PARAM_NAME;
              obj.PARAM_CAPTION = settData[item].PARAM_CAPTION;
              obj.IS_PAGING = settData[item].IS_PAGING;
              obj.DATA_TYPE = settData[item].DATA_TYPE;
              obj.ACTION_TYPE = settData[item].ACTION_TYPE;
              obj.IS_FAST_SEARCH = settData[item].IS_FAST_SEARCH;
              tempData.push(obj); // console.log('查询模式', tempData)
            }
          }); // console.log('tempData',tempData);

          _this4.columnsWhere = tempData;
        });
      },
      // 刷新重置
      refreshReset: function refreshReset() {
        var _this5 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var $table;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  Object.keys(_this5[formData]).map(function (keys) {
                    if (keys === 'ParamList') {
                      _this5[formData].ParamList = undefined;
                    }

                    if (keys === 'Page') {
                      _this5[formData].Page = 1;
                    }
                  });

                  _this5.$refs[mesTableRef].handleRefreshReset(); // 清除表格组件ParamList


                  _context4.next = 5;
                  return _this5.mainKeysLoad();

                case 5:
                  _context4.next = 7;
                  return _this5.handleLoadSearchData();

                case 7:
                  // 刷新列
                  $table = _this5.$refs[mesTableRef].$refs.xTable;
                  $table.refreshColumn();
                  _context4.next = 14;
                  break;

                case 11:
                  _context4.prev = 11;
                  _context4.t0 = _context4["catch"](0);
                  util.log.danger('没有通过refs找到MesTable组件的handleRefreshReset方法，请核对loadData、mesTableRef、formData、defaultLoadDataApi');

                case 14:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, null, [[0, 11]]);
        }))();
      },
      // 高级查询
      ParamList: function ParamList() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this[formData].ParamList = val;
        this.handleLoadSearchData();
      },
      handleParamList: function handleParamList(val) {
        // console.log('this.$refs[fastSearchRef]',this.$refs[fastSearchRef]);
        var theadParamList = this.$refs[fastSearchRef].getParamList();
        var ParamList = this.mergeParamList(theadParamList, val);
        this.ParamList(ParamList);
      },
      // 合并表头表体搜索条件
      mergeParamList: function mergeParamList() {
        var theadParamList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var tbodyParmamList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        // console.log('tbodyParmamList',tbodyParmamList);
        // 过滤好的表体搜索条件
        var filterTBodyParmamList = (tbodyParmamList === null || tbodyParmamList === void 0 ? void 0 : tbodyParmamList.filter(function (row) {
          // 不过滤高级搜索带过来的字段，暂时用OED_ID区分
          if (row.ORD_ID) {
            return true;
          } // 只保留表体项


          return !row.FIELD_NAME;
        })) || [];
        return theadParamList.concat(filterTBodyParmamList);
      },
      handleLoadSearchData: function handleLoadSearchData() {
        var _this6 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.prev = 0;
                  _context5.next = 3;
                  return _this6[loadData]();

                case 3:
                  _context5.next = 8;
                  break;

                case 5:
                  _context5.prev = 5;
                  _context5.t0 = _context5["catch"](0);
                  util.log.danger('未找到混入组件的' + loadData + '方法');

                case 8:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, null, [[0, 5]]);
        }))();
      },
      // 设置搜索方式
      settingColumn: function settingColumn(val) {
        this.handleSearchTableLoad();
      },
      // 方法排序
      customSortMethod: function customSortMethod(sortData) {
        var _this7 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
          var property, OrderBySort;
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  // console.log('排序', sortData)
                  property = sortData.property, OrderBySort = sortData.OrderBySort;
                  _this7[formData].OrderByParam = property;
                  _this7[formData].OrderBySort = OrderBySort;

                  _this7.handleLoadSearchData();

                case 4:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }))();
      },
      mainKeysLoad: function mainKeysLoad() {
        var _this8 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
          var res, TotalCount, data;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return LoadListFields({
                    USER_NAME: _this8.userinfo.USER_NAME
                  });

                case 2:
                  res = _context7.sent;

                  // const res = await LoadListFields({ USER_NAME: "ADMIN" })
                  // console.log('获取表格列 res',res);
                  if (res.code === 0) {
                    TotalCount = res.data.length;

                    if (TotalCount > 0) {
                      data = res.data || [];
                      _this8.mainKeys = data; // console.log('this.mainKeys',this.mainKeys);

                      _this8.$forceUpdate();
                    } else {
                      _this8.handleMaintableField();
                    }
                  }

                case 4:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }))();
      },
      handleMaintableField: function handleMaintableField() {
        var _this9 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
          var loading, res, resultData, isJsonString, blacklist, data, bindKeys, tempData;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  loading = _this9.$loading({
                    lock: true,
                    text: '正在创建列表信息,请稍后...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                  });
                  _context8.prev = 1;
                  _context8.next = 4;
                  return defaultLoadDataApi(_this9.formData);

                case 4:
                  res = _context8.sent;

                  // console.log('正在创建列表信息',res)
                  if (res.code !== 0) {
                    loading.close();
                  }

                  if (!(res.code === 0)) {
                    _context8.next = 24;
                    break;
                  }

                  resultData = [];
                  isJsonString = _this9.isJsonString(res.data);

                  if (isJsonString) {
                    resultData = JSON.parse(res.Result);
                  } else {
                    if (res.data.hasOwnProperty('data')) {
                      resultData = res.data.data;
                    } else {
                      resultData = res.data || [];
                    }
                  } // console.log('resultData',resultData);


                  if (!(resultData.Items.length > 0)) {
                    _context8.next = 22;
                    break;
                  }

                  blacklist = ['ID', '_XID', 'checked']; // 黑名单

                  data = resultData.Items[0];
                  bindKeys = [];
                  Object.keys(data).map(function (item) {
                    if (blacklist.indexOf(item) === -1) {
                      bindKeys.push(item);
                    }
                  });
                  tempData = [];
                  bindKeys.map(function (item, index) {
                    var obj = {};
                    obj.ORD_IDX = index + 1;
                    obj.FIELD_NAME = item;
                    obj.FIELD_CAPTION = item;
                    obj.FIELD_WIDTH = 140;
                    obj.IS_VISIBLE = 'Y';
                    obj.USER_NAME = _this9.userinfo.USER_NAME;
                    tempData.push(obj);
                  });
                  _context8.next = 19;
                  return _this9.SaveListFields(tempData);

                case 19:
                  loading.close();
                  _context8.next = 24;
                  break;

                case 22:
                  loading.close();
                  return _context8.abrupt("return", _this9.$notify({
                    title: '警告',
                    message: '暂无配置列信息，请在高级列进行配置',
                    type: 'warning'
                  }));

                case 24:
                  _context8.next = 30;
                  break;

                case 26:
                  _context8.prev = 26;
                  _context8.t0 = _context8["catch"](1);
                  console.log(_context8.t0);
                  loading.close();

                case 30:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, null, [[1, 26]]);
        }))();
      },

      /**
      * @name: 判断字符串是否是json 数据
      * @param {*} str
      * @return {*}
      */
      isJsonString: function isJsonString(str) {
        try {
          if (_typeof(JSON.parse(str)) === 'object') {
            return true;
          }
        } catch (e) {}

        return false;
      },
      SaveListFields: function SaveListFields(data) {
        var _this10 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return _SaveListFields(data);

                case 2:
                  _context9.next = 4;
                  return _this10.refreshReset();

                case 4:
                  _context9.next = 6;
                  return _this10.handleSearchTableLoad();

                case 6:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }))();
      }
    }
  };
}